import { makeStyles } from '@material-ui/core';

import { tiptapBlockMarginBottom, tiptapBlockMarginTop } from '../editorStyles';

export const useImageCardStyles = makeStyles(() => ({
  card: {
    backgroundColor: 'var(--background-highlight)',
    border: '1px solid transparent',
    borderRadius: 'var(--encore-corner-radius-larger-2)',
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    marginBottom: tiptapBlockMarginBottom,
    marginTop: tiptapBlockMarginTop,
    position: 'relative',
    width: '100%',
    '&:hover': {
      borderColor: 'var(--decorative-subdued)',
    },
    '& $hoverToolbar': {
      opacity: 0,
      pointerEvents: 'none' as const,
    },
    '&:hover $hoverToolbar, &$cardFocused $hoverToolbar, &:focus-within $hoverToolbar':
      {
        opacity: 1,
        pointerEvents: 'auto' as const,
      },
  },
  hoverToolbar: {
    position: 'absolute' as const,
    top: 0,
    right: 0,
    transform: 'translateY(-100%)',
    paddingBottom: 8,
    zIndex: 1000,
  },
  cardFocused: {
    '&, &:hover': {
      borderColor: 'var(--essential-base)',
    },
  },
  imageContainer: {
    alignItems: 'center',
    backgroundColor: 'var(--background-elevated-base)',
    borderRadius:
      'var(--encore-corner-radius-larger-2) var(--encore-corner-radius-larger-2) 0 0',
    display: 'flex',
    justifyContent: 'center',
    minHeight: 225,
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
  },
  image: {
    display: 'block',
    height: 'auto',
    objectFit: 'cover',
    maxHeight: 225,
    width: '100%',
  },
  imageButton: {
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    width: '100%',
    position: 'relative' as const,
    '& > [data-image-overlay]': {
      opacity: 0,
      transition: 'opacity 150ms ease-in-out',
    },
    '&:hover > [data-image-overlay]': {
      opacity: 1,
    },
  },
  imageOverlay: {
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    bottom: 0,
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
    left: 0,
    position: 'absolute' as const,
    right: 0,
    top: 0,
  },
  imagePlaceholder: {
    alignItems: 'center',
    backgroundColor: 'var(--background-tinted-base)',
    border: 'none',
    color: 'var(--text-base)',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    minHeight: 225,
    width: '100%',
    '&:hover': {
      backgroundColor: 'var(--background-tinted-highlight)',
      color: 'var(--text-base)',
    },
  },
  imagePlaceholderStatic: {
    alignItems: 'center',
    color: 'var(--essential-subdued)',
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--encore-spacing-tighter-2)',
    height: '100%',
    justifyContent: 'center',
    borderBottom: '1px solid var(--decorative-subdued)',
    minHeight: 225,
    width: '100%',
  },
  hiddenFileInput: {
    display: 'none',
  },
  contentContainer: {
    display: 'flex',
    gap: 'var(--encore-spacing-tighter-2)',
    flexDirection: 'column',
    padding: 'var(--encore-spacing-base)',
    '& > h2, & > h3': {
      color: 'var(--text-base)',
      fontSize: 'var(--encore-text-size-large)',
      fontWeight: 600,
      margin: 0,
    },
    '& > p': {
      color: 'var(--text-subdued)',
      fontSize: 'var(--encore-text-size-smaller)',
      lineHeight: 1.5,
      margin: 0,
    },
  },
}));
